import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { FlexboxGrid, Loader } from 'rsuite'

import { ResourceTag } from '../../utils/constants'
import { Catalog, Product } from '../../utils/types/Product'
import { useApi } from '../../services/useApi'
import ProductCarousel from '../Carousels/ProductCarousel'
import { AnalyticsProductCarouselTypes } from '../../utils/types/analytics'

import styles from '../../styles/CategorySpecificCarousel.module.less'

interface CategorySpecificCarouselProps {
  categories: Catalog[]
  className?: string
  title?: string
}

const CategorySpecificCarousel: FC<CategorySpecificCarouselProps> = (props) => {
  const { categories, className = '', title } = props

  const { t } = useTranslation('products')
  const { getResource } = useApi()

  // Only include top 3 category levels
  const filteredCategories = categories.filter((category) => Number(category?.['catalog.level']) < 4)

  const selectedCategory = filteredCategories.at(-1)
  const categoryId = selectedCategory?.id

  const headerText = categoryId ? t('Browse similar products') : `${t('Featured')} ${t('products')}`

  const query = `include=attribute,media,price,product,product/property,text,catalog,supplier,supplier/service,attribute/property,stock&filter[f_catid]=${categoryId}`
  const {
    data: products,
    isLoading,
  } = getResource<Product>(categoryId ? ResourceTag.product : null, query)

  if (isLoading) {
    return (
      <FlexboxGrid justify="center">
        <FlexboxGrid.Item>
          <Loader
            content="Loading products..."
            className="margin-top-spacer-tripple margin-bottom-spacer-half"
          />
        </FlexboxGrid.Item>
      </FlexboxGrid>
    )
  }

  if (products.length === 0 || !products[0]?.media?.length) {
    return null
  }

  return (
    <div
      data-testid="category-specific-carousel"
      className={`${styles['product-carousel']} ${className}`}
    >
      <ProductCarousel
        carouselType={AnalyticsProductCarouselTypes.RecommendedForYou}
        productCardType="narrow"
        title={title || headerText}
        products={products}
        className={styles['others-you-may-like-carousel']}
        titleSpacerClassName="padding-bottom-spacer"
      />
    </div>
  )
}

export default CategorySpecificCarousel
